import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RecoverPasswordService } from './recover-password.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'app-recover-password-dialog',
    templateUrl: './recover-password-dialog.component.html',
    styleUrls: ['./recover-password-dialog.component.scss'],
    standalone: false
})
export class RecoverPasswordDialogComponent implements OnInit {

  public recoverPasswordForm: FormGroup;
  errorMessage = '';
  successMessage = '';
  submitting = false;
  private _success = new Subject<string>();
  private _error = new Subject<string>();

  constructor(
    public activeModal: NgbActiveModal,
    private _fboulder: FormBuilder,
    private _recoverPassword: RecoverPasswordService,
  ) {}

  ngOnInit() {
    this.recoverPasswordForm = this._fboulder.group({
      email: ['', [Validators.required, Validators.email]]
    });
    this._success.subscribe(message => this.successMessage = message);
    this._success.pipe(
      debounceTime(4000)
    ).subscribe(() => this.successMessage = '');

    this._error.subscribe(message => this.errorMessage = message);
    this._error.pipe(
      debounceTime(7000)
    ).subscribe(() => this.errorMessage = '');
  }

  closeModal() {
    this.activeModal.close('Modal Closed');
  }

  /** Quita espacios al salir del campo (trim) para que Validators.email no falle. */
  normalizeEmail() {
    const ctrl = this.recoverPasswordForm.get('email');
    if (!ctrl) return;
    const normalized = String(ctrl.value || '').trim().toLowerCase();
    if (normalized !== ctrl.value) {
      ctrl.setValue(normalized);
    }
  }

  onSubmit() {
    this.normalizeEmail();

    if (this.recoverPasswordForm.invalid || this.submitting) {
      this.recoverPasswordForm.markAllAsTouched();
      return;
    }

    const email = String(this.recoverPasswordForm.value.email || '')
      .trim()
      .toLowerCase();

    if (!email) {
      this._error.next('Correo requerido');
      return;
    }

    this.submitting = true;
    this._recoverPassword.recoverPassword({ email }).then(
      data => {
        this.submitting = false;
        if (data['result']) {
          this._success.next('Te enviamos una contraseña temporal a tu correo. Al ingresar deberás establecer una nueva.');
          setTimeout(() => this.closeModal(), 4000);
        } else {
          this._error.next(this.errorFor(data?.['error']?.['message']));
        }
      },
      () => {
        this.submitting = false;
        this._error.next(this.errorFor(null));
      }
    );
  }

  /**
   * El backend distingue el motivo del fallo; antes todos terminaban en el
   * mismo texto ("Usuario deshabilitado o no existe"), que además mentía
   * cuando la cuenta sí existía y lo que falló fue el envío del correo.
   */
  private errorFor(backendMessage: string | null | undefined): string {
    if (backendMessage === 'User not found') {
      return 'No encontramos una cuenta activa con ese correo. Revísalo o contacta a soporte.';
    }
    if (backendMessage === 'Mail not sent') {
      return 'Tu cuenta existe, pero no pudimos enviarte el correo. Contacta a soporte.';
    }
    return 'No pudimos procesar la solicitud. Intenta de nuevo o contacta a soporte.';
  }
}
